import React, { FC, useCallback } from "react";
import { connect } from "react-redux";

import cn from "classnames";
import { useIntl } from "react-intl";

import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";
import { Modal } from "@mapmycustomers/ui";

import UsersSelect from "@app/component/UsersSelect";
import { getCurrentUser } from "@app/store/iam";
import { isOwner } from "@app/store/iam/util";
import { RootState } from "@app/store/rootReducer";

import { getTeamsToShareWith, getUsersToShareWith } from "../store";

import styles from "./ShareModal.module.scss";

export interface ShareModalProps {
  className?: string;
  currentUser: User;
  onChangeUserIds: (userIds: User["id"][]) => void;
  onHide: () => void;
  open: boolean;
  teams: Team[];
  title: string;
  userIds?: User["id"][];
  users: User[];
}

const ShareModal: FC<ShareModalProps> = ({
  className,
  currentUser,
  onChangeUserIds,
  onHide,
  open,
  teams,
  title,
  userIds,
  users,
}) => {
  const intl = useIntl();

  const handleApply = useCallback(
    (userIds: User["id"][]) => {
      onChangeUserIds(userIds);
      onHide();
    },
    [onChangeUserIds, onHide]
  );

  return (
    <Modal
      className={cn(styles.container, className)}
      destroyOnClose
      footer={null}
      onCancel={onHide}
      open={open}
      title={title}
      width="40rem"
    >
      <UsersSelect
        allUsersWhenEmpty={false}
        confirmText={intl.formatMessage({
          id: "resources.component.shareModal.confirm",
          defaultMessage: "Share",
          description: "Share confirm button",
        })}
        isCurrentUserOwner={isOwner(currentUser)}
        onApply={handleApply}
        onCancel={onHide}
        teams={teams}
        userIds={userIds?.filter((id) => id !== currentUser.id)}
        users={users}
      />
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  currentUser: getCurrentUser(state)!,
  teams: getTeamsToShareWith(state),
  users: getUsersToShareWith(state),
});

export default connect(mapStateToProps)(ShareModal);
